// extracted by css-extract-rspack-plugin
export default {"cls1":"OffsiteAuthorCard-cls1_zPZ","cls2":"OffsiteAuthorCard-cls2_Pih OffsiteAuthorCard-cls1_zPZ"};